// extracted by mini-css-extract-plugin
export default {"root":"nxhw7VoHIq7IJIAWZe8w","button":"QS46WlnMei90BLP1VK3Z","buttons":"d0YwyPPbFr2H9KXvy80A","label":"qWKGcN3cQ58B57FK1a5x","placeHolderShimmer":"w7vNLAtYUBhjkNQGlubL"};